export const extractApiErrorMessage = (error, fallbackMessage) => {
  const response = error?.response?.data;

  if (response?.message) {
    return response.message;
  }

  if (response?.error) {
    return response.error;
  }

  if (Array.isArray(response?.errors) && response.errors.length > 0) {
    return response.errors.join(', ');
  }

  return fallbackMessage;
};
